import jsPDF from "jspdf";
import dayjs from "dayjs";
import JsBarcode from "jsbarcode";

const calculateAge = (dob) => {
  const birthDate = dayjs(dob, "MMMM DD, YYYY");
  if (!birthDate.isValid()) {
    return "Invalid Date";
  }
  const now = dayjs();
  const years = now.diff(birthDate, "year");
  const months = now.diff(birthDate.add(years, "year"), "month");
  const days = now.diff(
    birthDate.add(years, "year").add(months, "month"),
    "day",
  );

  return `${years}Y ${months}M ${days}D`;
};
// const calculateAge = (dob) => {
//   const birthDate = dayjs(dob, "MMMM DD, YYYY");
//   const today = dayjs();
//   const diffInDays = today.diff(birthDate, "days");
//   if (diffInDays < 30) {
//     return `${diffInDays} days`;
//   }
//   let months = today.diff(birthDate, "months");
//   if (today.date() < birthDate.date()) {
//     months--;
//   }
//   if (months < 12) {
//     return `${months} months`;
//   }
//   let years = Math.floor(months / 12);
//   return `${years} years`;
// };
export const createInvoice = (
  invoice,
  pageSize = "a5",
  orientation = "landscape",
) => {
  const doc = new jsPDF({
    orientation: orientation, // 'portrait' or 'landscape' a4, a5
    unit: "mm",
    format: pageSize, // 'a4', 'a5', etc.
  });

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  let space = 35;
  let yPosition = space + 25; // Initial vertical position

  const addHeader = () => {
    console.log("name ", localStorage.getItem("orgName"));
    console.log("orgAddress1 ", localStorage.getItem("orgAddress1"));
    console.log("orgAddress2 ", localStorage.getItem("orgAddress2"));
    doc.setFillColor(255, 255, 255);
    doc.rect(0, 0, pageWidth, 30, "F");
    doc.setFontSize(20);
    doc.setFont("helvetica", "bold");
    doc.text(localStorage.getItem("orgName"), 14, 10);
    doc.setFontSize(10);
    doc.text(localStorage.getItem("orgAddress1"), 14, 15);
    doc.text(localStorage.getItem("orgAddress2"), 14, 20);
    doc.text(
      `Ph. ${localStorage.getItem("orgPhone")} | Email: ${localStorage.getItem(
        "orgEmail",
      )}`,
      14,
      25,
    );
    const imgSrc = localStorage.getItem("orgLogo");
    const imgWidth = 50; // Adjust width as needed
    const imgHeight = 30; // Adjust height as needed
    if (imgSrc) doc.addImage(imgSrc, "PNG", 145, 1, imgWidth, imgHeight);
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(10, 30, pageWidth - 10, 30);

    doc.setFontSize(10);
    doc.setTextColor(50, 50, 50);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Patient Name: ${invoice.patient.name} (${invoice.patient.patientID})`,
      14,
      space,
    );
    space += 5;
    doc.setFont("helvetica", "normal");
    doc.text(
      `Gender / Age: ${invoice.patient.gender} / ${calculateAge(
        invoice.patient.dob,
      )}`,
      14,
      space,
    );
    space += 5;
    doc.text(`Mobile: ${invoice.patient.mobile}`, 14, space);
    space += 5;
    doc.text(`Ref. By: ${invoice.doctor.name}`, 14, space);
    space += 5;
    doc.text(
      // `Center: ${invoice.center.centreName} (${invoice.center.centreId})`,
      `Center: ${invoice.center.centreId}`,
      14,
      space,
    );
    space = 35;
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 35);
    doc.text(`Invoice ID: ${invoice.invoiceId}`, pageWidth - 80, space);
    space += 5;
    const today = new Date();
    const timeStr = today.toLocaleTimeString();
    doc.text(
      `Date: ${invoice.invoiceSummary.billingDate}`,
      pageWidth - 80,
      space,
    );
    space += 5;
    doc.text(`Time: ${timeStr}`, pageWidth - 80, space);

    // Barcode generation
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, invoice.invoiceId, {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });
    const barcodeImage = barcodeCanvas.toDataURL("image/png");
    doc.addImage(barcodeImage, "PNG", pageWidth - 83, space + 1, 50, 13);

    //yPosition = 85; // Reset yPosition after header
  };

  const addTableHeader = () => {
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(10, yPosition, pageWidth - 10, yPosition);
    yPosition += 5;

    doc.setFontSize(10);
    doc.setTextColor(0);
    doc.setFont("helvetica", "bold");
    doc.text("Test Name", 20, yPosition);
    doc.text("Price (Rs.)", pageWidth - 60, yPosition);
    yPosition += 5;
  };

  const addNewPageIfNeeded = (extraSpace) => {
    if (yPosition + extraSpace > pageHeight - 40) {
      space = 35;
      yPosition = space + 25;
      doc.addPage();
      addHeader();
      addTableHeader();
    }
  };

  // Start document creation
  addHeader();
  addTableHeader();

  // Print all test information
  const testList = invoice?.invoiceSummary?.testList;
  testList.forEach((test, index) => {
    addNewPageIfNeeded(5);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(50, 50, 50);
    doc.text(`${index + 1}. ${test?.testName}`, 20, yPosition);
    doc.text(`Rs. ${test.testPrice?.toFixed(2)}`, pageWidth - 60, yPosition);
    yPosition += 5;
  });

  // Print amount details (Footer)
  const addFooter = () => {
    yPosition = pageHeight - 40;

    doc.setLineWidth(0.5);
    doc.line(10, yPosition, pageWidth - 10, yPosition);
    yPosition += 5;

    doc.setFont("helvetica", "bold");

    doc.text("Subtotal:", 20, yPosition);
    doc.text(
      `Rs. ${invoice.invoiceSummary?.subTotal?.toFixed(2)}`,
      pageWidth - 60,
      yPosition,
    );
    yPosition += 5;

    doc.text("Discount Offered:", 20, yPosition);
    doc.text(
      `Rs. ${invoice?.invoiceSummary?.totalDiscountOffered?.toFixed(2)}`,
      pageWidth - 60,
      yPosition,
    );
    yPosition += 5;

    doc.text("Grand Total:", 20, yPosition);
    doc.text(
      `Rs. ${invoice.invoiceSummary.total.toFixed(2)}`,
      pageWidth - 60,
      yPosition,
    );
    yPosition += 5;

    doc.text("Amount Collected:", 20, yPosition);
    doc.text(
      `Rs. ${invoice.invoiceSummary.amountCollected.toFixed(2)}`,
      pageWidth - 60,
      yPosition,
    );
    yPosition += 5;

    doc.text("Amount Due:", 20, yPosition);
    doc.text(
      `Rs. ${invoice.invoiceSummary.due.toFixed(2)}`,
      pageWidth - 60,
      yPosition,
    );
    yPosition += 10;

    // Footer Section
    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.setTextColor(100);
    doc.text(
      `Created By: ${invoice.userId.userName} / Last Modified By: ${
        invoice.userId.lastModifiedBy || "none"
      } / Printed By: ${localStorage.getItem("userName")} / Last Printed By: ${
        invoice?.lastInvoicePrintedBy || "none"
      }`,
      20,
      yPosition,
    );
  };

  addFooter();

  // Open the PDF in a new tab
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

export const createAdvice = (
  invoice,
  pageSize = "a5",
  orientation = "landscape",
) => {
  const doc = new jsPDF({
    orientation: orientation, // 'portrait' or 'landscape'
    unit: "mm",
    format: pageSize, // 'a4', 'a5', etc.
  });
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  let yPosition = 40; // Initial vertical position

  const addHeader = () => {
    doc.setFontSize(22);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.text(localStorage.getItem("orgName"), 14, 20);

    doc.setFontSize(15);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.text("Laboratory Advice Slip", 14, 30);

    doc.setFontSize(10);
    doc.setTextColor(50, 50, 50);
    doc.setFont("helvetica", "bold");
    doc.text(
      `Patient Name: ${invoice.patient.name} (${invoice.patient.patientID})`,
      14,
      40,
    );
    doc.text(
      `Gender / Age: ${invoice.patient.gender} / ${calculateAge(
        invoice.patient.dob,
      )}`,
      14,
      45,
    );
    doc.text(`Mobile: ${invoice.patient.mobile}`, 14, 50);
    doc.text(`Ref. By: ${invoice.doctor.name}`, 14, 55);
    doc.text(
      `Center: ${invoice.center.centreName} (${invoice.center.centreId})`,
      14,
      60,
    );

    doc.setFontSize(10);
    doc.setTextColor(0, 0, 35);
    doc.text(`Invoice ID: ${invoice.invoiceId}`, pageWidth - 80, 40);
    doc.text(`Date: ${invoice.invoiceSummary.billingDate}`, pageWidth - 80, 45);
    const today = new Date();
    doc.text(`Time: ${today.toLocaleTimeString()}`, pageWidth - 80, 50);

    // Barcode generation
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, invoice.invoiceId, {
      format: "CODE128",
      width: 2,
      height: 30,
      displayValue: false,
    });
    const barcodeImage = barcodeCanvas.toDataURL("image/png");
    // doc.addImage(barcodeImage, "PNG", pageWidth - 83, 55, 50, 13);
    doc.addImage(barcodeImage, "PNG", pageWidth - 83, 50, 50, 13);

    yPosition = 65; // Reset yPosition after header
  };

  const addTableHeader = () => {
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(10, yPosition, pageWidth - 10, yPosition); // Draw line for table header
    yPosition += 10;
  };

  const addNewPage = () => {
    doc.addPage();
    addHeader();
    addTableHeader();
  };

  // Start document generation
  addHeader();
  addTableHeader();

  // Separate tests by category
  const pathologyTests = invoice.invoiceSummary.testList.filter(
    (test) => test.testCat === "pathology",
  );
  const radiologyTests = invoice.invoiceSummary.testList.filter(
    (test) => test.testCat === "radiology",
  );
  const microbiologyTests = invoice.invoiceSummary.testList.filter(
    (test) => test.testCat === "microbiology",
  );

  // Print Pathology Tests only if available
  if (pathologyTests.length > 0) {
    doc.setFont("helvetica", "bold");
    doc.text("Pathology", 105, yPosition, { align: "center" });
    yPosition += 10;

    pathologyTests.forEach((test, indx) => {
      doc.setFont("helvetica", "normal");
      doc.setTextColor(50, 50, 50);
      doc.text(`${indx + 1}. ${test.testName}`, 20, yPosition);
      yPosition += 6;

      if (yPosition > pageHeight - 10) {
        addNewPage();
      }
    });
  }

  // Handle Radiology Tests by Department
  if (radiologyTests.length > 0) {
    //   if (pathologyTests.length > 0) {
    //     addNewPage();
    //   }

    const groupedRadiologyTests = radiologyTests.reduce((acc, test) => {
      if (!acc[test.testDept]) acc[test.testDept] = [];
      acc[test.testDept].push(test);
      return acc;
    }, {});

    Object.entries(groupedRadiologyTests).forEach(
      ([department, tests], index) => {
        if (index > 0 || pathologyTests.length > 0) {
          addNewPage();
        }

        doc.setFont("helvetica", "bold");
        doc.text(`${department}`, 105, yPosition, {
          align: "center",
        });
        yPosition += 10;

        tests.forEach((test, indx) => {
          doc.setFont("helvetica", "normal");
          doc.setTextColor(50, 50, 50);
          doc.text(`${indx + 1}. ${test.testName}`, 20, yPosition);
          yPosition += 10;

          if (yPosition > pageHeight - 10) {
            addNewPage();
          }
        });
      },
    );
  }

  if (microbiologyTests.length > 0) {
    if (pathologyTests.length > 0 || radiologyTests.length > 0) {
      addNewPage();
    }
    doc.setFont("helvetica", "bold");
    doc.text("Microbiology", 105, yPosition, { align: "center" });
    yPosition += 10;

    microbiologyTests.forEach((test, indx) => {
      doc.setFont("helvetica", "normal");
      doc.setTextColor(50, 50, 50);
      doc.text(`${indx + 1}. ${test.testName}`, 20, yPosition);
      yPosition += 6;

      if (yPosition > pageHeight - 10) {
        addNewPage();
      }
    });
  }

  // Handle case when no tests are available
  if (
    pathologyTests.length === 0 &&
    radiologyTests.length === 0 &&
    microbiologyTests.length === 0
  ) {
    doc.setFont("helvetica", "italic");
    doc.text("No tests available.", 105, yPosition, { align: "center" });
  }
  yPosition = pageHeight - 5;
  doc.setFontSize(8);
  doc.setFont("helvetica", "italic");
  doc.setTextColor(100);
  doc.text(
    `Created By: ${invoice.userId.userName} / Last Modified By: ${
      invoice.userId.lastModifiedBy || "none"
    } / Printed By: ${localStorage.getItem("userName")} / Last Printed By: ${
      invoice?.lastAdvicePrintedBy || "none"
    }`,
    20,
    yPosition,
  );
  // Open the PDF in a new tab
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
};

export const createBoth = (
  invoice,
  pageSize = "a5",
  orientation = "landscape",
) => {
  const doc = new jsPDF({
    orientation: orientation,
    unit: "mm",
    format: pageSize,
  });

  // --- 1. Invoice ---
  // reuse your createInvoice but stop before saving/opening
  const generateInvoice = () => {
    // call your createInvoice logic here but use `doc` passed instead of creating a new one
    // you’ll need to refactor createInvoice slightly:
    // - accept an existing `doc` object as argument
    // - don’t call `doc.output` or `window.open`
    // (only draw)
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    let space = 35;
    let yPosition = space + 25; // Initial vertical position

    const addHeader = () => {
      doc.setFillColor(255, 255, 255);
      doc.rect(0, 0, pageWidth, 30, "F");
      doc.setFontSize(20);
      doc.setFont("helvetica", "bold");
      doc.text(localStorage.getItem("orgName"), 14, 10);
      doc.setFontSize(10);
      doc.text(localStorage.getItem("orgAddress1"), 14, 15);
      doc.text(localStorage.getItem("orgAddress2"), 14, 20);
      doc.text(
        `Ph. ${localStorage.getItem(
          "orgPhone",
        )} | Email: ${localStorage.getItem("orgEmail")}`,
        14,
        25,
      );
      const imgSrc = localStorage.getItem("orgLogo");
      const imgWidth = 50; // Adjust width as needed
      const imgHeight = 30; // Adjust height as needed
      if (imgSrc) doc.addImage(imgSrc, "PNG", 145, 1, imgWidth, imgHeight);
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(10, 30, pageWidth - 10, 30);

      doc.setFontSize(10);
      doc.setTextColor(50, 50, 50);
      doc.setFont("helvetica", "bold");
      doc.text(
        `Patient Name: ${invoice.patient.name} (${invoice.patient.patientID})`,
        14,
        space,
      );
      space += 5;
      doc.setFont("helvetica", "normal");
      doc.text(
        `Gender / Age: ${invoice.patient.gender} / ${calculateAge(
          invoice.patient.dob,
        )}`,
        14,
        space,
      );
      space += 5;
      doc.text(`Mobile: ${invoice.patient.mobile}`, 14, space);
      space += 5;
      doc.text(`Ref. By: ${invoice.doctor.name}`, 14, space);
      space += 5;
      doc.text(
        // `Center: ${invoice.center.centreName} (${invoice.center.centreId})`,
        `Center: ${invoice.center.centreId}`,
        14,
        space,
      );
      space = 35;
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 35);
      doc.text(`Invoice ID: ${invoice.invoiceId}`, pageWidth - 80, space);
      space += 5;
      const today = new Date();
      const timeStr = today.toLocaleTimeString();
      doc.text(
        `Date: ${invoice.invoiceSummary.billingDate}`,
        pageWidth - 80,
        space,
      );
      space += 5;
      doc.text(`Time: ${timeStr}`, pageWidth - 80, space);

      // Barcode generation
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, invoice.invoiceId, {
        format: "CODE128",
        width: 2,
        height: 30,
        displayValue: false,
      });
      const barcodeImage = barcodeCanvas.toDataURL("image/png");
      doc.addImage(barcodeImage, "PNG", pageWidth - 83, space + 1, 50, 13);

      //yPosition = 85; // Reset yPosition after header
    };

    const addTableHeader = () => {
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(10, yPosition, pageWidth - 10, yPosition);
      yPosition += 5;

      doc.setFontSize(10);
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text("Test Name", 20, yPosition);
      doc.text("Price (Rs.)", pageWidth - 60, yPosition);
      yPosition += 5;
    };

    const addNewPageIfNeeded = (extraSpace) => {
      if (yPosition + extraSpace > pageHeight - 40) {
        space = 35;
        yPosition = space + 25;
        doc.addPage();
        addHeader();
        addTableHeader();
      }
    };

    // Start document creation
    addHeader();
    addTableHeader();

    // Print all test information
    const testList = invoice?.invoiceSummary?.testList;
    testList.forEach((test, index) => {
      addNewPageIfNeeded(5);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(50, 50, 50);
      doc.text(`${index + 1}. ${test?.testName}`, 20, yPosition);
      doc.text(`Rs. ${test.testPrice?.toFixed(2)}`, pageWidth - 60, yPosition);
      yPosition += 5;
    });

    // Print amount details (Footer)
    const addFooter = () => {
      yPosition = pageHeight - 40;

      doc.setLineWidth(0.5);
      doc.line(10, yPosition, pageWidth - 10, yPosition);
      yPosition += 5;

      doc.setFont("helvetica", "bold");

      doc.text("Subtotal:", 20, yPosition);
      doc.text(
        `Rs. ${invoice.invoiceSummary?.subTotal?.toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Discount Offered:", 20, yPosition);
      doc.text(
        `Rs. ${invoice?.invoiceSummary?.totalDiscountOffered?.toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Grand Total:", 20, yPosition);
      doc.text(
        `Rs. ${invoice.invoiceSummary.total.toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Amount Collected:", 20, yPosition);
      doc.text(
        `Rs. ${invoice.invoiceSummary.amountCollected.toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 5;

      doc.text("Amount Due:", 20, yPosition);
      doc.text(
        `Rs. ${invoice.invoiceSummary.due.toFixed(2)}`,
        pageWidth - 60,
        yPosition,
      );
      yPosition += 10;

      // Footer Section
      doc.setFontSize(8);
      doc.setFont("helvetica", "italic");
      doc.setTextColor(100);
      doc.text(
        `Created By: ${invoice.userId.userName} / Last Modified By: ${
          invoice.userId.lastModifiedBy || "none"
        } / Printed By: ${localStorage.getItem(
          "userName",
        )} / Last Printed By: ${invoice?.lastInvoicePrintedBy || "none"}`,
        20,
        yPosition,
      );
    };

    addFooter();
  };

  // --- 2. Advice ---
  const generateAdvice = () => {
    doc.addPage(); // advice should start on new page
    // call your createAdvice logic here but again with same doc
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    let yPosition = 40; // Initial vertical position

    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.text(localStorage.getItem("orgName"), 14, 20);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");
      doc.text("Laboratory Advice Slip", 14, 30);

      doc.setFontSize(10);
      doc.setTextColor(50, 50, 50);
      doc.setFont("helvetica", "bold");
      doc.text(
        `Patient Name: ${invoice.patient.name} (${invoice.patient.patientID})`,
        14,
        40,
      );
      doc.text(
        `Gender / Age: ${invoice.patient.gender} / ${calculateAge(
          invoice.patient.dob,
        )}`,
        14,
        45,
      );
      doc.text(`Mobile: ${invoice.patient.mobile}`, 14, 50);
      doc.text(`Ref. By: ${invoice.doctor.name}`, 14, 55);
      doc.text(
        `Center: ${invoice.center.centreName} (${invoice.center.centreId})`,
        14,
        60,
      );

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 35);
      doc.text(`Invoice ID: ${invoice.invoiceId}`, pageWidth - 80, 40);
      doc.text(
        `Date: ${invoice.invoiceSummary.billingDate}`,
        pageWidth - 80,
        45,
      );
      const today = new Date();
      doc.text(`Time: ${today.toLocaleTimeString()}`, pageWidth - 80, 50);

      // Barcode generation
      const barcodeCanvas = document.createElement("canvas");
      JsBarcode(barcodeCanvas, invoice.invoiceId, {
        format: "CODE128",
        width: 2,
        height: 30,
        displayValue: false,
      });
      const barcodeImage = barcodeCanvas.toDataURL("image/png");
      // doc.addImage(barcodeImage, "PNG", pageWidth - 83, 55, 50, 13);
      doc.addImage(barcodeImage, "PNG", pageWidth - 83, 50, 50, 13);

      yPosition = 65; // Reset yPosition after header
    };

    const addTableHeader = () => {
      doc.setDrawColor(200, 200, 200);
      doc.setLineWidth(0.5);
      doc.line(10, yPosition, pageWidth - 10, yPosition); // Draw line for table header
      yPosition += 10;
    };

    const addNewPage = () => {
      doc.addPage();
      addHeader();
      addTableHeader();
    };

    // Start document generation
    addHeader();
    addTableHeader();

    // Separate tests by category
    const pathologyTests = invoice.invoiceSummary.testList.filter(
      (test) => test.testCat === "pathology",
    );
    const radiologyTests = invoice.invoiceSummary.testList.filter(
      (test) => test.testCat === "radiology",
    );
    const microbiologyTests = invoice.invoiceSummary.testList.filter(
      (test) => test.testCat === "microbiology",
    );

    // Print Pathology Tests only if available
    if (pathologyTests.length > 0) {
      doc.setFont("helvetica", "bold");
      doc.text("Pathology", 105, yPosition, { align: "center" });
      yPosition += 10;

      pathologyTests.forEach((test, indx) => {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(50, 50, 50);
        doc.text(`${indx + 1}. ${test.testName}`, 20, yPosition);
        yPosition += 6;

        if (yPosition > pageHeight - 10) {
          addNewPage();
        }
      });
    }

    // Handle Radiology Tests by Department
    if (radiologyTests.length > 0) {
      //   if (pathologyTests.length > 0) {
      //     addNewPage();
      //   }

      const groupedRadiologyTests = radiologyTests.reduce((acc, test) => {
        if (!acc[test.testDept]) acc[test.testDept] = [];
        acc[test.testDept].push(test);
        return acc;
      }, {});

      Object.entries(groupedRadiologyTests).forEach(
        ([department, tests], index) => {
          if (index > 0 || pathologyTests.length > 0) {
            addNewPage();
          }

          doc.setFont("helvetica", "bold");
          doc.text(`${department}`, 105, yPosition, {
            align: "center",
          });
          yPosition += 10;

          tests.forEach((test, indx) => {
            doc.setFont("helvetica", "normal");
            doc.setTextColor(50, 50, 50);
            doc.text(`${indx + 1}. ${test.testName}`, 20, yPosition);
            yPosition += 10;

            if (yPosition > pageHeight - 10) {
              addNewPage();
            }
          });
        },
      );
    }

    if (microbiologyTests.length > 0) {
      if (pathologyTests.length > 0 || radiologyTests.length > 0) {
        addNewPage();
      }
      doc.setFont("helvetica", "bold");
      doc.text("Microbiology", 105, yPosition, { align: "center" });
      yPosition += 10;

      microbiologyTests.forEach((test, indx) => {
        doc.setFont("helvetica", "normal");
        doc.setTextColor(50, 50, 50);
        doc.text(`${indx + 1}. ${test.testName}`, 20, yPosition);
        yPosition += 6;

        if (yPosition > pageHeight - 10) {
          addNewPage();
        }
      });
    }

    // Handle case when no tests are available
    if (
      pathologyTests.length === 0 &&
      radiologyTests.length === 0 &&
      microbiologyTests.length === 0
    ) {
      doc.setFont("helvetica", "italic");
      doc.text("No tests available.", 105, yPosition, { align: "center" });
    }
    yPosition = pageHeight - 5;
    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.setTextColor(100);
    doc.text(
      `Created By: ${invoice.userId.userName} / Last Modified By: ${
        invoice.userId.lastModifiedBy || "none"
      } / Printed By: ${localStorage.getItem("userName")} / Last Printed By: ${
        invoice?.lastAdvicePrintedBy || "none"
      }`,
      20,
      yPosition,
    );
  };

  // Run both
  generateInvoice();
  generateAdvice();

  // Save / Open final combined PDF
  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
  // or doc.save(`Invoice_Advice_${invoice.invoiceId}.pdf`);
};
